<template>
  <span>
    {{ categories }}
  </span>
</template>
<script>
import gql from "fraql";
import { sortBy } from "lodash-es";
export default {
  name: "AppShowEventCategories",
  props: {
    eventCategories: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    categories() {
      return sortBy(this.eventCategories, "rank")
        .map(x => x.name)
        .join(", ");
    }
  },
  fragments: {
    eventCategoryFields: gql`
      fragment _ on EventCategory {
        id
        name
        rank
      }
    `
  }
};
</script>
